import { TestSearchEngine } from "@theme/test-search";

/**
 * B2B "Was testen wir?" search (Geschäftspartner page). Client-side search over
 * the rich product-metaobject category cards (intro + subitems) with match
 * highlighting and an expand-all toggle. The shared clamp component
 * (<test-funktioniert-clamp-component>) is registered by the test-search.js import.
 *
 * @extends {TestSearchEngine}
 */
class TestFunktioniertB2bComponent extends TestSearchEngine {
  get searchConfig() {
    return {
      category: ".test-search__category",
      matchClass: "test-search__category--match",
      summary: ".test-search__cat-summary",
      filterables: ".test-search__cat-intro, .test-search__subitem",
      highlightables: [
        ".test-search__cat-intro",
        ".test-search__sub-title",
        ".test-search__sub-intro",
        ".test-search__items",
      ],
      expandAll: ".test-search__expand-all",
    };
  }

  extractCategoryTitle(summary) {
    return (
      summary.querySelector(".test-search__cat-title")?.textContent.trim() || ""
    );
  }
}

if (!customElements.get("test-funktioniert-b2b-component")) {
  customElements.define("test-funktioniert-b2b-component", TestFunktioniertB2bComponent);
}
